import { useId } from 'react';
import type { ReactElement } from 'react';

import { Hero } from '@xing-com/typography';

import type { BasicCardProps } from './basic-card.types';
import {
  CardBenefitsList,
  CardContainer,
  CardHeaderSection,
  CardMembershipStatus,
} from './sub-components';

export type { BasicCardProps } from './basic-card.types';

export const BasicCard = ({
  title,
  status,
  benefitsTitle,
  benefits,
}: BasicCardProps): ReactElement => {
  const titleId = useId();

  return (
    <CardContainer
      aria-labelledby={titleId}
      as="article"
      data-product-card="basic"
      size="large"
      padding="regular"
    >
      <CardHeaderSection>
        <Hero as="h2" id={titleId} size="small" noMargin>
          {title}
        </Hero>
        <CardMembershipStatus>{status}</CardMembershipStatus>
      </CardHeaderSection>
      <CardBenefitsList benefits={benefits} benefitsTitle={benefitsTitle} />
    </CardContainer>
  );
};
